module.exports = __webpack_public_path__ + "img/thumb-logo-jumpsa.d153eb17.png";